module.exports = __webpack_public_path__ + "img/no-data.36beada6.svg";